import React from "react";
import { Dropdown } from "react-bootstrap";
// icons
import { MdEdit } from "react-icons/md";

/* Component for TableDropdownButton in the edit column */
interface TableEditDropdownButtonProps {
  index: number;
  modalID: string;
  items: {
    text: React.ReactElement;
    onClick: (event) => void;
  }[];
}

/**
 * A dropdown menu for editing a person's details, providing various edit options.
 *
 * @param index   Unique key for identifying the dropdown instance.
 * @param modalID Identifier for modals triggered by dropdown actions.
 * @param items   List of menu items, each containing a label and an onClick handler.
 */
const TableEditDropdownButton = ({
  index,
  modalID,
  items,
}: TableEditDropdownButtonProps) => {
  return (
    <Dropdown key={index}>
      <Dropdown.Toggle
        variant={"outline-secondary"}
        id={`dropdown-basic-button-${index}`}
        aria-label="bearbeiten"
      >
        {<MdEdit size={16} />}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {items.map((item, itemIndex) => (
          <Dropdown.Item
            key={`dropdown-item-${itemIndex}`}
            id={modalID}
            onClick={item.onClick}
          >
            {item.text}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default TableEditDropdownButton;
